import React from 'react';
import { Link } from 'react-router-dom';
import { useSparks } from '../../contexts/SparksContext';
import { formatSparks } from '../../api/sparksApi';
import SparksCount from './SparksCount';
import './sparks.css';

/**
 * Nav chip "12,400 ✨" that counts up, with floating "+N" pop-ups beside it (design §2.6).
 * While a question is on screen the nav is hidden and SparksAddyBurst draws the bubbles from
 * Addy instead, so the chip stays silent then (`burstMounted`), and while the lesson recap counts the
 * Sparks up itself (`recapOpen`). Balances always carry a
 * thousands separator and never sit inside a sentence.
 */
export default function SparksBadge({ linkTo = '/shop' }) {
  const { balance, pops, capNotice, enabled, burstMounted, recapOpen, navReady } = useSparks();

  // Drawn only once there is a balance, which then shows as is; counting up from 0 on every page load jiggled the nav.
  if (!enabled || !navReady) return null;

  return (
    <div className="sparks-badge-wrap relative shrink-0">
      <Link
        to={linkTo}
        title="Your Sparks — spend them in Addy's Shop"
        className="sparks-badge flex items-center gap-1 px-2.5 py-1 rounded-full bg-[#FFD966] text-[#2F1E6B] text-sm font-bold select-none hover:bg-[#ffe58a] transition-colors"
        data-testid="sparks-balance"
        data-sparks-tip="sparks"
      >
        <SparksCount value={balance} />
        <span aria-hidden>✨</span>
      </Link>
      {!burstMounted && !recapOpen && (
        <div className="sparks-pops pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-1 flex flex-col items-center gap-1">
          {pops.map((p) => (
            <div key={p.id} className="sparks-pop whitespace-nowrap font-bold text-[#2F1E6B] bg-white/95 border border-[#FFD966] rounded-full px-3 py-1 shadow" style={{ animationDelay: `${p.delay}ms` }}>
              +{formatSparks(p.amount)} {p.label}
            </div>
          ))}
        </div>
      )}
      {capNotice && !burstMounted && (
        <div className="sparks-cap-notice absolute right-0 top-full mt-1 text-xs bg-white text-[#2F1E6B] border border-[#E6DDFB] rounded-lg px-3 py-2 shadow w-64 z-50">
          {capNotice}
        </div>
      )}
    </div>
  );
}
